module.exports = __webpack_public_path__ + "assets/img/swiper-1.00d2ddc1.jpg";